import { render, staticRenderFns } from "./remits.vue?vue&type=template&id=60904304&scoped=true&"
import script from "./remits.vue?vue&type=script&lang=js&"
export * from "./remits.vue?vue&type=script&lang=js&"
import style0 from "./remits.vue?vue&type=style&index=0&id=60904304&prod&lang=css&"
import style1 from "./remits.vue?vue&type=style&index=1&id=60904304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60904304",
  null
  
)

export default component.exports